import React from 'react';
import { Card, Badge } from '@/components/ui';
import type { ConstructionQaInspection } from '../types/construction-qa.types';

interface Props {
  inspection: ConstructionQaInspection;
}

export const QaInspectionOverview: React.FC<Props> = ({ inspection }) => {
  return (
    <Card className="p-6">
      <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2">
        <i className="ri-information-line text-os-primary" />
        Thông tin chung phiếu kiểm tra
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-12">
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Mã phiếu</span>
          <span className="text-sm font-mono font-bold text-os-primary">{inspection.inspection_code}</span>
        </div>
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Loại kiểm tra</span>
          <span className="text-sm font-bold text-slate-700">{inspection.inspection_type}</span>
        </div>
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Dự án</span>
          <span className="text-sm font-bold text-slate-700">{inspection.project?.name}</span>
        </div>
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Khu vực</span>
          <span className="text-sm font-bold text-os-primary underline">{inspection.zone?.name || '---'}</span>
        </div>
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Người kiểm tra</span>
          <span className="text-sm font-bold text-slate-700">{inspection.inspector?.full_name}</span>
        </div>
        <div className="flex justify-between border-b border-slate-50 pb-2">
          <span className="text-sm text-slate-500">Ngày kiểm tra</span>
          <span className="text-sm font-bold text-slate-700">
            {inspection.inspected_at ? new Date(inspection.inspected_at).toLocaleDateString('vi-VN') : '---'}
          </span>
        </div>
      </div>

      {inspection.notes && (
        <div className="mt-6">
          <p className="text-[10px] text-slate-400 font-bold  mb-2  tracking-wider">Ghi chú kiểm tra</p>
          <p className="text-sm text-slate-600 bg-slate-50 p-4 rounded-2xl border border-slate-100 italic">
            "{inspection.notes}"
          </p>
        </div>
      )}
    </Card>
  );
};
